import React from 'react';

import { Text, TextProps } from '@/components/ui/text';
import { useAssociation } from '@/hooks/use-data';

export const AssociationName: React.FC<{ id: string } & TextProps> = ({ id, ...props }) => {
	const { data: association } = useAssociation(id);
	return <Text {...props}>{association?.name}</Text>;
};
